import { SVGProps } from "react";

export function CheckWithBG(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      {...props}
    >
      <circle cx="60" cy="60" r="60" fill="#CE72F8" fill-opacity="0.2" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M81.6106 51.0479C84.4594 53.0999 86.3938 56.2799 86.3938 59.9999C86.3938 63.7199 84.4594 66.9023 81.6106 68.9519C82.1866 72.4127 81.289 76.0511 78.6658 78.6719C76.0378 81.2999 72.4018 82.1735 68.9554 81.6119C66.913 84.4703 63.7042 86.3999 59.9938 86.3999C56.2738 86.3999 53.0866 84.4631 51.0394 81.6095C47.5882 82.1735 43.9497 81.3023 41.3193 78.6719C38.6913 76.0439 37.8178 72.4055 38.3986 68.9519C35.5522 66.9047 33.5938 63.7223 33.5938 59.9999C33.5938 56.2775 35.5522 53.0927 38.3986 51.0479C37.8178 47.5943 38.6913 43.9559 41.3217 41.3279C43.945 38.7023 47.5858 37.8071 51.0586 38.3831C53.0938 35.5295 56.281 33.5999 59.9938 33.5999C63.7018 33.5999 66.9058 35.5271 68.9506 38.3831C72.4114 37.8071 76.045 38.7071 78.6658 41.3279C81.2866 43.9487 82.189 47.5871 81.6106 51.0479ZM70.9882 50.8463C71.2447 51.0294 71.4627 51.2613 71.6297 51.5286C71.7966 51.796 71.9093 52.0936 71.9612 52.4045C72.0131 52.7154 72.0033 53.0335 71.9323 53.3406C71.8613 53.6477 71.7305 53.9378 71.5473 54.1943L59.5474 70.9943C59.3448 71.2781 59.0828 71.5143 58.7797 71.6865C58.4766 71.8587 58.1397 71.9628 57.7922 71.9916C57.4448 72.0204 57.0953 71.9731 56.768 71.8531C56.4407 71.7331 56.1434 71.5433 55.897 71.2967L48.697 64.0967C48.2598 63.6441 48.0179 63.0379 48.0233 62.4086C48.0288 61.7793 48.2812 61.1774 48.7262 60.7324C49.1712 60.2874 49.7731 60.035 50.4024 60.0295C51.0317 60.0241 51.6379 60.266 52.0905 60.7031L57.2866 65.8991L67.6402 51.4031C68.0103 50.8854 68.571 50.5358 69.1988 50.4314C69.8267 50.327 70.4703 50.4762 70.9882 50.8463Z"
        fill="#CE72F8"
      />
    </svg>
  );
}

